var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.303.455c2.753 0 5 2.247 5 5l.002 1.772a3.008 3.008 0 0 1 1.998 2.828v7h-14v-7c0-1.302.837-2.414 2-2.828V5.455c0-2.753 2.248-5 5-5Zm4 8.6h-8c-.547 0-1 .452-1 1v5h10v-5c0-.548-.452-1-1-1Zm-4-6.6c-1.647 0-3 1.352-3 3v1.6h6v-1.6c0-1.648-1.352-3-3-3Z",
    fill: "currentColor"
  })));
};
export default SvgLock;